import { SlotEventConstantsBehavior, SoundConstant, RetriggerController } from "@quest/murka-games-behavior-leopard/dist";
import {
  AnimationBase,
  ITween,
  ingenuity,
  SpineBase,
  LabelBitmap,
  delayedCall,
  killDelayedCall,
  Linear,
  Meter,
  dispatcher,
  Container,
  Label,
} from "@quest/base-core";
import { Model as platformModel } from "@quest/platform-murka/dist/Model/Model";

import { SoundConstantGame } from "../Constants/SoundConstantGame";
import { gameConstants } from "../Constants/gameConstants";
import { RetriggerViewGame } from "./RetriggerViewGame";
import { View } from "../FreeGame/View";
import { eventDispatchers } from "../Constants/EventDispatchers";

export class RetriggerControllerGame extends RetriggerController {
  protected view: RetriggerViewGame;
  protected freeGameView: View;
  protected retriggerSpine: SpineBase;
  protected retriggerSpineContainer: Container;
  private textSpine: SpineBase;
  protected retriggerPortraitSpine: SpineBase;
  protected retriggerPortraitBGSpine: SpineBase;
  protected retriggerText: LabelBitmap;




  /**
   * Subscribe events
   */
  protected subscribeEvents(): void {
    this.unsubscribeEvents();
    dispatcher.on(eventDispatchers.START_RETRIGGER_PRESENTATION, this.onRetriggerShow, this);
  }

  /**
   * Unsubscribe events
   */
  protected unsubscribeEvents(): void {
    dispatcher.off(eventDispatchers.START_RETRIGGER_PRESENTATION, this.onRetriggerShow, this);
  }

  // Override to initialize elements
  protected initializeElements(): void {
    this.retriggerSpineContainer = this.view.getContainerByID("retriggerSpineContainer");
    this.retriggerSpine = this.retriggerSpineContainer.children[0];
    this.textSpine = this.retriggerSpineContainer.children[1].children[0];
    this.retriggerText = this.view.getLabelById("retriggerText") as LabelBitmap;
    !ingenuity.deviceEnv.isDesktop && this.initializePortraitComponent();
  }

  /**
   * Initialize retrigger intro portrait elements
   */
  protected initializePortraitComponent(): void {
    this.retriggerPortraitSpine = this.view.getContainerByID("retriggerSpineContainerPortrait").children[0];
    this.retriggerPortraitBGSpine = this.view.getContainerByID("retriggerBGSpineContainerPortrait").children[0];
  }

  // Override to start retrigger presentation
  protected onRetriggerShow(): void {
    dispatcher.fireEvent(eventDispatchers.SHOW_BLUR_BACKGROUND, eventDispatchers.SHOW_RETRIGGER_BLUR_BG);
    dispatcher.fireEvent(SlotEventConstantsBehavior.ADD_FG_BUTTON_PANEL_ON_TOP);
    if ((ingenuity.soundManager as any).getSoundInstance(SoundConstant.FREGAME_BGLOOP, gameConstants.SOUND_LIST_POSTLOAD)) {
      (ingenuity.soundManager as any).getSoundInstance(SoundConstant.FREGAME_BGLOOP, gameConstants.SOUND_LIST_POSTLOAD).volume = 0.5;
    }
    if ((ingenuity.soundManager as any).getSoundInstance(SoundConstantGame.FREE_GAME_BGM, gameConstants.SOUND_LIST_POSTLOAD)) {
      (ingenuity.soundManager as any).getSoundInstance(SoundConstantGame.FREE_GAME_BGM, gameConstants.SOUND_LIST_POSTLOAD).volume = 0.5;
    }
    this.showRetriggerText();
    this.showRetriggerSpine();
    (ingenuity.soundManager as any).playSound(SoundConstantGame.RETRIGGER_POP_UP_SOUND, 1, false, gameConstants.SOUND_LIST_POSTLOAD);
    delayedCall(
      "changeGrid",
      200,
      () => {
        killDelayedCall("changeGrid");
        this.updateStaticGrid();
      },
      this
    );
  }

  protected updateStaticGrid(): void {
    const position: number[][] = (ingenuity.parserModel as platformModel).getRetriggerOffSet();
    let grid = (ingenuity.parserModel as platformModel).getReelGrid();
    position &&
      position.forEach((offset: number[]) => {
        grid[offset[0]][offset[1] + 4] = gameConstants.FREESPIN_WITHOUT_NUM;
      });
    this.freeGameView.getReelView().showStaticGrid(grid);
  }

  // Show retrigger intro spine
  protected showRetriggerSpine(): void {
    if (ingenuity.deviceEnv.isDesktop) {
      this.playRetriggerDesktopSpine();
    } else {
      this.playRetriggerDesktopSpine();
      this.playRetriggerPortraitSpine();
    }
  }

  // Add to play desktop retrigger spine
  protected playRetriggerDesktopSpine(): void {
    this.retriggerSpine.visible = true;
    this.textSpine.visible = true;
    this.textSpine.setPause(false);
    this.retriggerSpine.playAnim("in_bg_desktop", false);
    this.textSpine.playAnim("in_retrigger", false);
    this.textSpine.onComplete.addOnce(() => {
      this.retriggerSpine.playAnim("loop_bg_desktop", false);
      this.textSpine.playAnim("loop_retrigger", false);
      this.textSpine.onComplete.addOnce(() => {
        this.retriggerSpine.playAnim("out_bg_desktop", false);
        this.textSpine.playAnim("out_retrigger", false);
        this.textSpine.onComplete.addOnce(() => {
          this.retriggerSpine.visible = false;
          this.textSpine.visible = false;
        }, this);
      }, this);
    }, this);
  }

  // Add to play mobile portrait retrigger spine
  protected playRetriggerPortraitSpine(): void {
    this.retriggerPortraitSpine.visible = true;
    this.retriggerPortraitBGSpine.visible = true;
    this.retriggerPortraitBGSpine.playAnim("in_bg_portrait", false);
    this.retriggerPortraitSpine.playAnim("in_retrigger", false);
    this.retriggerPortraitSpine.onComplete.addOnce(() => {
      this.retriggerPortraitBGSpine.playAnim("loop_bg_portrait", false);
      this.retriggerPortraitSpine.playAnim("loop_retrigger", false);
      this.retriggerPortraitSpine.onComplete.addOnce(() => {
        this.retriggerPortraitBGSpine.playAnim("out_bg_portrait", false);
        this.retriggerPortraitSpine.playAnim("out_retrigger", false);
        this.retriggerPortraitSpine.onComplete.addOnce(() => {
          this.retriggerPortraitBGSpine.visible = false;
          this.retriggerPortraitSpine.visible = false;
        }, this);
      }, this);
    }, this);
  }

  // Show retrigger text with fade in effect
  protected showRetriggerText(): void {
    this.retriggerText.visible = false;
    this.retriggerText.rotation = -0.16;
    this.retriggerText.alpha = 0;
    const fadeInTween: ITween = ingenuity.currentGame.add.tween(this.retriggerText).to({ alpha: 1 }, 500, Linear.None, true, 300, 0, false);
    fadeInTween.onComplete.addOnce(() => {
      fadeInTween.stop();
      ingenuity.currentGame.tweens.remove(fadeInTween);
      this.hideRetriggerText();
      delayedCall(
        "counterAnimDelay",
        1800,
        () => {
          killDelayedCall("counterAnimDelay");
          this.showFreeGameCounterAnimation();
        },
        this
      );
    }, this);
  }

  // Hide retrigger text with fade out effect
  protected hideRetriggerText(): void {
    dispatcher.fireEvent(eventDispatchers.HIDE_BLUR_BACKGROUND, eventDispatchers.HIDE_RETRIGGER_BLUR_BG);
    const fadeOutTween: ITween = ingenuity.currentGame.add
      .tween(this.retriggerText)
      .to({ alpha: 0 }, 600, Linear.None, true, 1500, 0, false);
    fadeOutTween.onComplete.addOnce(() => {
      fadeOutTween.stop();
      ingenuity.currentGame.tweens.remove(fadeOutTween);
    }, this);
  }

  // Show free game counter animation
  protected showFreeGameCounterAnimation(): void {
    const fgCounterAnimation: AnimationBase = this.freeGameView.getAnimationById("fgHitAnimation");
    fgCounterAnimation.visible = true;
    fgCounterAnimation.playAnim(
      "anim",
      () => {
        fgCounterAnimation.visible = false;
        this.updateTotalFreeSpin();
      },
      this
    );
  }

  // Update total free spin
  protected updateTotalFreeSpin(): void {
    if ((ingenuity.soundManager as any).getSoundInstance(SoundConstant.FREGAME_BGLOOP, gameConstants.SOUND_LIST_POSTLOAD)) {
      (ingenuity.soundManager as any).getSoundInstance(SoundConstant.FREGAME_BGLOOP, gameConstants.SOUND_LIST_POSTLOAD).volume = 1;
    }
    if ((ingenuity.soundManager as any).getSoundInstance(SoundConstantGame.FREE_GAME_BGM, gameConstants.SOUND_LIST_POSTLOAD)) {
      (ingenuity.soundManager as any).getSoundInstance(SoundConstantGame.FREE_GAME_BGM, gameConstants.SOUND_LIST_POSTLOAD).volume = 1;
    }
    const remainingFg: Meter = this.freeGameView.getMeterById("RemainingFreespin") as Meter;
    remainingFg.setValue((ingenuity.parserModel as platformModel).getFreeSpinsRemaining());
   
    let freeCounterText;
    if (remainingFg.getValue() <= 1) {
      freeCounterText = remainingFg.getValue() + " " + ingenuity.currentGame.cache.getJSON("lang").free_Spin.text
    } else {
      freeCounterText = remainingFg.getValue() + " " + ingenuity.currentGame.cache.getJSON("lang").free_SpinsCount.text
    }

    const freeSpinsText = this.freeGameView.getLabelById("freespinsLeftText") as Label;
    if (ingenuity.deviceEnv.isDesktop) {
      freeSpinsText.setText(freeCounterText)
    } else {
      freeSpinsText.text = freeCounterText
    }

    delayedCall(
      "sendNextSpinAfterPresentation",
      3000,
      () => {
        killDelayedCall("sendNextSpinAfterPresentation");
        dispatcher.fireEvent(SlotEventConstantsBehavior.MOVE_TO_NEXT_FREESPIN_AFTER_RETRIGGER);
      },
      this
    );
  }

  // reset events
  public reset(): void {
    this.unsubscribeEvents();
  }
}
